import domReady from "@wordpress/dom-ready";
import { createRoot } from "@wordpress/element";
import RulesApp from "./RulesApp";
import "./style.scss";
domReady(() => {
    const root = createRoot(document.getElementById("wpb-pmqb-rules-app"));
    root.render(<RulesApp />);
});
